import * as Popover from "@radix-ui/react-popover";
import { COMMENT_TYPE } from "store/apis/notes";
import classNames from "classnames";
import { AddCommentPop } from "components/AddComment/AddComment";
import ConditionalToolTip from "components/design/conditionalToolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { ChatTeardropDots } from "components/icons/ChatTeardropDots";
import AddCommentIcon from "static/images/AddComment.svg";
import { Transactions as TransactionsType } from "types/Models/books";
import { useState } from "react";

export const AddTransactionComment = ({
  transactionDetails,
  zIndexClass,
  hasWritePermission,
}: {
  transactionDetails: TransactionsType;
  zIndexClass?: string;
  hasWritePermission: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasComments = transactionDetails.comments_count > 0;

  if (!hasWritePermission && !hasComments) return null;

  return (
    <div
      className={classNames(
        "hover:t-bg-surface t-flex t-justify-center t-items-center t-rounded",
        {
          "t-opactity-100": transactionDetails.comments_count > 0,
          "t-opacity-0 group-hover:t-opacity-100":
            transactionDetails.comments_count === 0,
        }
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
        <Popover.Trigger asChild>
          <span>
            <ConditionalToolTip
              condition={
                transactionDetails.comments_count === 0 && "Add Comment"
              }
            >
              <Button customType="ghost" size="small">
                <div className="t-flex t-items-center t-text-text-30 t-text-caption t-gap-0.5">
                  {transactionDetails.comments_count > 0 ? (
                    <>
                      <ChatTeardropDots />
                      {transactionDetails.comments_count || ""}
                    </>
                  ) : (
                    <img src={AddCommentIcon} alt="AddComment" />
                  )}
                </div>
              </Button>
            </ConditionalToolTip>
          </span>
        </Popover.Trigger>
        <Popover.Portal>
          <AddCommentPop
            commentType={COMMENT_TYPE.TRANSACTION_COMMENT}
            contentId={transactionDetails.transaction.uuid}
            zIndexClass={zIndexClass}
            readOnly={!hasWritePermission}
          />
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
};
